export enum JobStatus {
    waiting = 'waiting',
    submiterror = 'submiterror',
    error = 'error',
    start = 'start',
    running = 'running',
    complete = 'complete'
}

export interface IJob {
    stop: () => void,
    info: {
        status: JobStatus,
        jobName: string,
        // [key: string]: any
        viewer: {
            name: string,
            value: string,
        }[]
    }
}


export interface IJobAction {
    type: string,
    payload?: IJobListen
}

export interface IJobListen {
    [key: string]: IJob
}

const jobListenDefault = {};

function jobReducer(state: IJobListen = jobListenDefault, action: IJobAction): IJobListen {

    switch (action.type) {
        case "PROGRESS_UPDATE_JOB":
            return Object.assign({}, state, action.payload);
        case "PROGRESS_REFRESH_JOB":
            return Object.assign({}, action.payload);
        case "PROGRESS_CLEAR":
            return jobListenDefault;
        default:
            return state;
    }
}
export default jobReducer;